/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useLabels } from '@/hooks/useLabels';
import { View } from '@az/starc-ui';
import { Icon } from '@az/starc-ui';
import { StarFill } from '@az/starc-ui-icons';

type RatingProps = {
  stars: number;
};

const labelMap = {
  outOf5Stars: 'label_reviews_outOf5Stars',
};

const steps = new Array<number>(5).fill(0);

export const Rating = ({ stars }: RatingProps) => {
  const labels = useLabels(labelMap);

  return (
    <span aria-label={`${stars} ${labels.outOf5Stars}`} role={'img'}>
      <View direction={'row'}>
        {steps.map((_, index) => (
          <Icon
            title={'star'}
            key={`rev-${index}`}
            svg={StarFill}
            color={index < stars ? 'accent' : '300'}
            size={{ s: 6, m: 7 }}
          />
        ))}
      </View>
    </span>
  );
};
